import { render, staticRenderFns } from "./brick_file_subcomponent_file_selection.vue?vue&type=template&id=bfbcec0c&"
import script from "./brick_file_subcomponent_file_selection.vue?vue&type=script&lang=js&"
export * from "./brick_file_subcomponent_file_selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports